import { setBanner, setLoad, setUnload } from 'lib/notification/actions'
import { httpDelete } from 'lib/http'
import { unsetModal } from 'lib/modal/actions'
import { Button } from 'components/Button'
import styles from './styles'


export const DeleteLineItem = (props: Props) => {
  const {number, subnumber, id, dispatch, onSuccess} = props
  
  const handleConfirm = () => {
    dispatch(setLoad())
    
    const url = `/admin/accounts/${number}/subaccounts/${subnumber}/line-items/${id}`
    httpDelete(url)
      .then(() => {
        dispatch(setBanner('Transaction successfully deleted'))
        dispatch(unsetModal())
        if (onSuccess) onSuccess()
      })
      .catch(() => {
        dispatch(setBanner('Transaction deletion failed', 'danger'))
      })
      .finally(() => {
        dispatch(setUnload())
      })
  }

  const handleCancel = () => {
    dispatch(unsetModal())
  }

  return (
    <section >
      <h4 className="section">Delete Transaction</h4>
      <p>Are you sure you want to delete this transaction? This action cannot be undone.</p>
      <div className={styles.row}>
        <Button size="default" color="blue" label="Cancel"  onClick={handleCancel}/>
        <Button size="default" color="red" label="Confirm"  onClick={handleConfirm}/>
      </div>
    </section>
  )
}